import React from 'react'
import dodatafound from '../../../assets/images/dodatafound.svg'
import '../participantfiles/noParticipantsFound.css'

interface NoDataFoundProps {
  title?: string;
  description?: string;
}

const NoDataFound: React.FC<NoDataFoundProps> = ({ 
  title = "No Data Found",
  description = "There is no data to show you right now"
}) => {
  return (
    <div className="no-participants-found-container">
      <div className="no-data-found-wrapper">
        <img className="no-data-found-image" src={dodatafound} alt="No Data Found" />
        <div className="no-data-found-content">
          <span className="no-data-found-title">{title}</span>
          <span className="no-data-found-description">{description}</span>
        </div>
      </div>
    </div>
  )
}

export default NoDataFound

